import React from 'react';

interface FooterSectionHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const FooterSectionHeader: React.FC<FooterSectionHeaderProps> = ({ children, className = '' }) => {
  return (
    <div className={`self-stretch pt-1.5 pb-[16px] flex items-center ${className}`}>
      <div className="text-[#C3B89F] text-xs font-bold leading-[16.8px] tracking-[0.6px] uppercase font-['Figtree']">
        {children}
      </div>
    </div>
  );
};
